/**
 * Translate the revamped backend's response/error shape into the legacy
 * `{ status, message, data }` contract the redux-saga error branches expect.
 * `res` is an axios `error.response` (has `.status` and `.data`), or undefined on a network error.
 */
export function normalizeError(res) {
  if (!res) {
    return {
      status: 'network_error',
      message: 'Network error',
      data: undefined,
    };
  }
  const { status, data } = res;
  const message = (data && data.message) || 'Request failed';
  const nested = data && data.data && data.data.status;

  if (message === 'Token_error') {
    return { status: 'Token_error', message, data };
  }
  if (status === 403 && message === 'Super-admin access required') {
    return { status: 'Token_error', message, data };
  }
  if (status === 403 && message === 'Email not verified') {
    return { status: 'email-not-verified', message, data };
  }
  if (nested === 'company-not-found' || nested === 'invalid-company-id') {
    return { status: 'company-not-found', message, data: data.data };
  }
  if (nested === 'access-removed') {
    return { status: 'access-removed', message, data: data.data };
  }
  if (nested === 'switch-company') {
    // Membership revoked for the active company; backend points us at a fallback.
    return { status: 'switch-company', message, data: data.data };
  }
  if (status === 422) {
    const issues = (data && data.errorData && data.errorData.issues) || [];
    return {
      status: 'validation_error',
      message,
      data: issues.map((i) => ({
        param: (i.path || []).join('.'),
        msg: i.message,
      })),
    };
  }
  if (status === 429) {
    return { status: 'limit_error', message, data };
  }
  return {
    status: (data && data.status) || 'error',
    message,
    data: data && data.data,
  };
}
